import { render, staticRenderFns } from "./dialog-evaluate.vue?vue&type=template&id=977355d8&scoped=true&"
import script from "./dialog-evaluate.vue?vue&type=script&lang=js&"
export * from "./dialog-evaluate.vue?vue&type=script&lang=js&"
import style0 from "./dialog-evaluate.vue?vue&type=style&index=0&id=977355d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977355d8",
  null
  
)

export default component.exports